import { Dayjs } from 'dayjs';
import { DateTrigger, DateTriggerPrecision } from 'src/components/DateTrigger';
import { CustomAttributeValue } from 'src/graphql/entities/custom-attributes/custom-attributes.types';
import { useAttributeCommit } from 'src/graphql/entities/custom-attributes/field-view-registry/components/attribute-select-menu';
import { CustomAttributeEditProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { toDayjs, toIso } from 'src/utils/date';

type DateKind = 'date' | 'date_time';

// Fills the row's own content height so the control does not sit squashed inside it.
const DATE_TRIGGER_SX = { width: '100%', minHeight: '2rem' };

const renderDateEditor = (kind: DateKind, precision: DateTriggerPrecision) => {
  const Editor = ({
    value,
    definition: { label },
    onChange,
    onSave,
    disabled,
    saving,
    timezone,
  }: CustomAttributeEditProps) => {
    const commit = useAttributeCommit({ onChange, onSave });
    const write = (next: Dayjs | null) =>
      commit({ kind, value: toIso(next) } as CustomAttributeValue);

    return (
      <DateTrigger
        label={label}
        value={toDayjs(getKindLikeValueSafely(value, kind)) ?? null}
        precision={precision}
        timezone={timezone}
        onChange={write}
        onClear={() => write(null)}
        loading={saving}
        disabled={disabled}
        sx={DATE_TRIGGER_SX}
      />
    );
  };
  Editor.displayName = `${kind === 'date' ? 'Date' : 'DateTime'}Editor`;
  return Editor;
};

export const DateEditor = renderDateEditor('date', 'date');

export const DateTimeEditor = renderDateEditor('date_time', 'date-time');
